import { createAsyncThunk } from '@reduxjs/toolkit'
import ExpressedPreference from './expressed-preference-model'
import {
  delete_expressedPreference,
  load_expressedPreferences,
  store_expressedPreference,
} from './expressedPreference-service'

export const LoadExpressedPreferencesAsync = createAsyncThunk<any, any>(
  'composer/load/expressedPreference',
  async (params: { uid: string }) => {
    return await load_expressedPreferences(params)
  },
)

export const CreateExpressedPreferenceAsync = createAsyncThunk<any, any>(
  'composer/create/expressedPreference',
  async (params: ExpressedPreference) => {
    return await store_expressedPreference(params)
  },
)

export const DeleteExpressedPreferenceAsync = createAsyncThunk<any, any>(
  'composer/delete/expressedPreference',
  async (params) => {
    return await delete_expressedPreference(params)
  },
)
